import Cookies from "js-cookie";
import { useIntl } from "react-intl";
import { notifyError, notifyInfo, notifySuccess } from "./notify";

export const useAddToWishlist = (API_URL) => {
    const intl = useIntl();

    const addToWishlist = async (id) => {
        const loginRequiredMsg = intl.formatMessage({ id: "wishlist_login_required", defaultMessage: "Zaloguj się, aby dodać do listy życzeń." });
        const addedMsg = intl.formatMessage({ id: "wishlist_added", defaultMessage: "Dodano do listy życzeń!" });
        const alreadyAddedMsg = intl.formatMessage({ id: "wishlist_already_added", defaultMessage: "Produkt już na liście życzeń." });
        const failedMsg = intl.formatMessage({ id: "wishlist_add_failed", defaultMessage: "Błąd dodawania do listy życzeń." });

        const rawUser = Cookies.get("user");

        if (!rawUser) {
            notifyInfo(loginRequiredMsg);
            return;
        }
        const user = JSON.parse(rawUser);
        const token = Cookies.get("token");
        if (!user.id || !token) {
            notifyInfo(loginRequiredMsg);
            return;
        }

        try {
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            };
            // GET /wishlists/me returns a single wishlist object, not a list.
            const resGet = await fetch(`${API_URL}/wishlists/me`, { headers });
            if (!resGet.ok) throw new Error(`GET /wishlists/me ${resGet.status}`);
            const jsonGet = await resGet.json();
            const current = jsonGet.data?.products?.map((p) => p.documentId) || [];

            if (current.includes(id)) {
                notifyInfo(alreadyAddedMsg);
                return;
            }

            // The backend merges these documentIds into the existing list.
            const resPut = await fetch(`${API_URL}/wishlists/me`, {
                method: "PUT",
                headers,
                body: JSON.stringify({ data: { products: [id] } }),
            });
            if (!resPut.ok) throw new Error(`PUT /wishlists/me ${resPut.status}`);
            notifySuccess(addedMsg);
        } catch (err) {
            console.error("Error adding to wishlist:", err);
            notifyError(failedMsg);
        }
    };

    return addToWishlist;
};
export default useAddToWishlist;